import { TextInputField } from 'evergreen-ui';
import React from 'react';
import { useController } from 'react-hook-form';
import { createUseStyles } from 'react-jss';
import { formStyles } from '../../styles/sharedComponentStyles';
import { getError } from './helpers';

const useSharedStyles = createUseStyles({
  ...formStyles,
});

const InputTextField = ({
  label,
  name,
  disabled,
  defaultValue,
  isInvalid,
  control,
  showErrorMessage,
  required,
  ...rest
}) => {
  const { field, fieldState } = useController({ control, name, defaultValue });
  const { hasError, errorMessage } = getError(fieldState);
  const sharedClasses = useSharedStyles();

  return (
    <TextInputField
      {...field}
      value={field.value || ''}
      name={name}
      label={label}
      validationMessage={showErrorMessage ? errorMessage : undefined}
      required={required}
      disabled={disabled}
      className={sharedClasses.roundedInput}
      onChange={(e) => field.onChange(e.target.value)}
      style={{
        padding: '20px',
      }}
      isInvalid={hasError}
      {...rest}
    />
  );
};

export default InputTextField;
